import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import ReactDOM from 'react-dom';

var PopperRoot = null;
var MessageBoxRoot = null;
var DebuggerConsoleRoot = null;
var initPortalRoots = function initPortalRoots(getRoot) {
  if (!PopperRoot || !MessageBoxRoot || !DebuggerConsoleRoot) {
    PopperRoot = document.createElement('div');
    PopperRoot.id = 'smbPoperRoot';
    document.body.appendChild(PopperRoot);
    MessageBoxRoot = document.createElement('div');
    MessageBoxRoot.id = 'smbMessageBoxRoot';
    document.body.appendChild(MessageBoxRoot);
    DebuggerConsoleRoot = document.createElement('div');
    DebuggerConsoleRoot.id = 'smbDebuggerConsoleRoot';
    document.body.appendChild(DebuggerConsoleRoot);
  }

  return {
    Popper: PopperRoot,
    MessageBox: MessageBoxRoot,
    DebuggerConsole: DebuggerConsoleRoot
  }[getRoot];
};
var Portal = function Portal(_ref) {
  var children = _ref.children;

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return null;
  }

  var PopperRoot = initPortalRoots('Popper');
  return /*#__PURE__*/ReactDOM.createPortal(children, PopperRoot);
};
var MessageBoxPortal = function MessageBoxPortal(_ref2) {
  var children = _ref2.children;

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return null;
  }

  var MessageBoxRoot = initPortalRoots('MessageBox');
  return /*#__PURE__*/ReactDOM.createPortal(children, MessageBoxRoot);
};
var DebuggerConsolePortal = function DebuggerConsolePortal(_ref3) {
  var children = _ref3.children;

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return null;
  }

  var DebuggerConsoleRoot = initPortalRoots('DebuggerConsole');
  return /*#__PURE__*/ReactDOM.createPortal(children, DebuggerConsoleRoot);
};

export { DebuggerConsolePortal, MessageBoxPortal, Portal, initPortalRoots };
